import React from "react";
import styles from "./StayTouch.module.css";

const StayTouch = () => {
  return (
    <div className={styles.Container}>
      <div className={styles.SubHeading}>Stay in touch</div>
      <div className={styles.Normal}>
        If I write something new, I'll let you know if you are interested in
        learning new stuffs.
      </div>
      <div className={styles.AboutMe}>
        <a
          href="https://hrusikesh.substack.com/"
          target="_blank"
          rel="noreferrer"
        >
          Subscribe to the Newsletter
        </a>
      </div>
    </div>
  );
};

export default StayTouch;
